var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",class:`${_vm.type} ${_vm.absolute ? 'absolute' : ''}`},[(_vm.$slots.icon)?_c('div',[_vm._t("icon")],2):_vm._e(),_vm._v("\n  "+_vm._s(_vm.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }